<template>
  <el-dialog :append-to-body="true" id="privacy-layer" title="正元签电子合同用户隐私政策" :visible.sync="dialogVisible" width="506px" :center="true">
    <p>欢迎您使用正元签电子合同。本隐私政策（以下简称“本政策”）适用于北京正元安服科技有限公司（以下简称“正元安服”或“我们”）官网网站及使用正元安服产品和服务。</p>
    <p>本应用尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。 您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。</p>
    <p>本隐私权政策属于本应用服务使用协议不可分割的一部分。您同意《正元签电子合同用户注册说明协议》，即视为您已经阅读并同意本政策的全部内容，如果您不同意本政策的条款，应停止使用服务。</p>
    <p>本政策将帮助您了解以下内容：</p>
    <p>一、名词解释</p>
    <p>二、我们如何收集您的个人信息；</p>
    <p>三、我们如何使用 Cookie 和同类技术；</p>
    <p>四、我们如何共享、无偿转让、公开您的个人信息；</p>
    <p>五、我们如何保存和保护您的个人信息；</p>
    <p>六、您管理个人信息的权利；</p>
    <p>七、本政策的变更和修订；</p>
    <p>八、如何联系我们；</p>
    <p>一、名词解释</p>
    <p>哈希值：又称:散列函数(或散列算法，又称哈希函数，英语:Hash Function)是一种从任何一种数据中创建小的数字"指纹"的方法。散列函数把消息或数据压缩成摘要，使得数据量变小，将数据的格式固定下来。该函数将数据打乱混合，重新创建一个叫做散列值(hash values，hash codes，hash sums，或hashes)的指纹。散列值通常用一个短的随机字母和数字组成的字符串来代表。好的散列函数在输入域中很少出现散列冲突。在散列表和数据处理中，不抑制冲突来区别数据，会使得数据库记录更难找到。</p>
    <p>二、我们如何收集您的个人信息</p>
    <p>我们会依据合法、合规、合理的原则，向您收集必要的个人信息，并对信息进行规范使用。我们会收集以下您个人或者企业的信息：</p>
    <p>(一)为实现产品功能所需的信息</p>
    <p>1.注册账户信息：</p>
    <p>您首次注册正元签电子合同时，需要提供个人的手机号码、电子邮箱并创建登录名称和密码，如果您不提供这些信息，将不能使用我们产品的服务。</p>
    <p>2.实名认证信息：</p>
    <p>您在使用本产品进行签发文件时，需要进行实名认证，所以需要提供您的真实姓名、个人身份证号码、身份证正反面照片、人脸识别视频、个人手写签名及其他您提供的认证信息。收集这些信息是为了满足国家相关法律法规的实名制要求，若您不提供这些信息，会无法完成您的实名认证，就无法以实名信息进行文件的签发。</p>
    <p>如果您需要注册企业的账户，我们还需要收集您的企业名称、企业营业执照号、法定代表人姓名、法定代表人身份证号码、企业营业执照（三证合一）以及注册人的身份证正反面照片。</p>
    <p>(二)您使用过程中的信息</p>
    <p>我们会收集您主动上传到我们平台的合同原文文件、合同哈希值或者其他书面形式的材料，并对信息进行安全存储。我们不会主动收集您的这些信息，只有在您主动提交合同审阅时收集。如果您提供的是他人信息，需要您得到对方的授权并保证对方已经知道且接受本协议。如果您提供的信息造成他人损害的，您将自行承担后果。</p>
    <p>(三)服务运行信息</p>
    <p>为了维护我们产品服务的正常运行及账号安全，需要收集您以下信息：</p>
    <p>1.设备信息：</p>
    <p>根据您在软件安装及使用时的授权，收集记录您的设备相关信息（设备型号、操作系统版本、唯一设备标识符、IP地址、软件版本号等软硬件信息）。</p>
    <p>2.日志信息：</p>
    <p>收集您在使用我们服务时的信息（登录时间、操作内容及时间、故障信息和接入网络方式等信息），作为日志保存。</p>
    <p>3.反馈信息</p>
    <p>如果您通过我们的客服、网站留言或参加我们举办的活动时所提交的信息：当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
    <p>(四)其他用途</p>
    <p>我们将基于本政策未载明的其他特定目的收集您的信息时，会事先征求您的同意。如果我们停止运营云全运电子合同产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</p>
    <p>(五)例外</p>
    <p>依据国家相关法律法规，在以下情况时收集您的个体信息无需征求到您的同意：</p>
    <p>1.与国家安全、国防安全有关的；</p>
    <p>2.与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3.与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>4.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
    <p>5.所收集的个人信息是您自行向社会公众公开的；</p>
    <p>6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
    <p>7.根据您的要求签订合同所必需的；</p>
    <p>8.用于维护所提供的产品或服务的安全稳定运行所必需的，例如处理产品或服务的故障；</p>
    <p>9.法律法规规定的其他情形。</p>
    <p>三、我们如何使用 Cookie 和同类技术</p>
    <p>为使您获得更好的产品体验，在您使用我们的产品或服务时，我们可能会通过采用各种技术收集和存储您访问正元签电子合同服务的相关数据，在您访问或再次访问正元签电子合同服务时,我们能识别您的身份，并通过分析数据为您提供更好更多的服务。包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入账户信息的步骤，或者帮助判断您的登录状态以及账户安全。这些数据文件可能是Cookie、Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。</p>
    <p>我们不会将 Cookies 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。您可以清除计算机上保存的所有 Cookies，大部分网络浏览器都有自动接受Cookies功能，您也可根据自己的需要来修改设置用于拒绝 Cookies或者清除软件内保存的所有Cookies。</p>
    <p>四、我们如何共享、转让、公开您的个人信息</p>
    <p>(一)共享</p>
    <p>我们不会与正元安服以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
    <p>1.在事先得到您明确同意的情况下；</p>
    <p>2.在相关的法律法规、法律程序的要求、强制性的行政或司法要求等必须的情况下提供您的个人信息；</p>
    <p>3.只有共享您的信息，才能实现我们的产品和服务的电子合同签约发起、编辑、签署、验证、下载、打印等核心功能或提供您需要的服务；</p>
    <p>4.在您合法需求或者监护人合法需求情况下，协助处理您与他人的纠纷或争议；</p>
    <p>5.根据与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</p>
    <p>6.与授权的供应商和服务提供方共享：为实现本政策中声明的目的，我们个别服务是我们与授权供应商/服务提供方共同提供，我们会依据法律法规与他们共享您的某些个人信息，具体如下：</p>
    <p>（1）我们会将您的真实姓名、身份证信息共享给电子商务认证授权机构（CA, Certificate Authority），其中有山西省数字证书认证中心（山西CA）、内蒙古数字证书认证有限公司（内蒙CA）、安信电子认证中心（安信CA）。</p>
    <p>（2）我们会将您的真实姓名、身份证信息、手机号码，以及人脸识别信息共享给提供本产品实名认证服务的机构。</p>
    <p>（3）通过SDK的方式共享：某些产品或服务可能由我们服务提供方提供，我们会通过SDK的形式向您提供产品或服务，在此过程中，我们的服务提供方可能会收集、使用和存储你的相关数据或信息。</p>
    <p>我们仅会出于合法、合规、特定的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息。我们的供应商和服务提供方无权将共享的用户信息用于任何其他用途。我们将信息发送给支持我们业务的供应商、服务提供商，这些支持包括提供基础技术服务等专业服务。例如，在您申请实名认证时，我们会将您的个人信息传输至实名认证服务提供方，以便其完成对您的实名认证。</p>
    <p>您在接受或使用第三方产品或服务前应充分了解第三方产品或服务的条款及政策，如果您发现有第三方服务提供者存有相关违法违规行为，可以向正元安服投诉，我们将查实后予以处理。</p>
    <p>(二)无偿转让</p>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>1.在获取您明确同意的情况下转让；</p>
    <p>2.在正元签电子合同服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>
    <p>(三)公开披露</p>
    <p>我们仅会在以下情况下，才会披露您的信息：</p>
    <p>1.在您明确同意的披露方式下披露您所指定的个人信息；</p>
    <p>2.在法律、法规的要求、强制性的行政执法或司法要求所必须提供您信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的信息。在向强制性的行政执法或司法机关披露后机关允许的前提下，我们会及时通知您。</p>
    <p>(四)共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
    <p>以下情形中，我们共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
    <p>1、与国家安全、国防安全关联的；</p>
    <p>2、与公共安全、公共卫生、重大公共利益关联的；</p>
    <p>3、与犯罪侦查、起诉、审判和判决执行等关联的；</p>
    <p>4、 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
    <p>5、您自行向社会公众公开的个人信息；</p>
    <p>6、 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等。</p>
    <p>五、我们如何保存和保护您的个人信息</p>
    <p>(一)保存信息</p>
    <p>我们在中华人民共和国境内收集和产生的信息，会存储在中国境内。我们只在本政策所属目的所必须期间和法律法规要求的时限内存储您的个人信息，根据《电子签名法》规定，我们会保存您的个人信息至少五年。）但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：</p>
    <p>1.为遵守适用的法律法规等有关规定；</p>
    <p>2.为遵守法院判决、裁定或其他法律程序的规定；</p>
    <p>3.为遵守相关政府机关或法定授权组织的要求；</p>
    <p>4.我们有理由确信需要遵守法律法规等有关规定；</p>
    <p>5.为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。</p>
    <p>(二)保护信息</p>
    <p>我们将采取以下手段保护您的信息：</p>
    <p>1.数据安全技术措施</p>
    <p>我们会采用符合业界标准的安全防护措施，安全技术解决方案来防止您的信息遭到未经授权的访问、使用、篡改,避免数据的损坏丢失或泄露。网络服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）来保护您的信息，采取加密技术对您的信息进行加密保存，并通过隔离技术进行隔离。</p>
    <p>2.我们为保护个人信息采取的其他安全措施</p>
    <p>对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的数据保护条款，要求其按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。我们仅允许有必要知晓个人信息的员工访问您的信息，并为此设置了严格的访问权限控制和监控机制。对于关键岗位员工录用前我们都会经过背景调查，同时要求可能接触到您的信息的所有人员签订保密协议并履行相应的保密义务。</p>
    <p>3.个人隐私数据泄露事件处置</p>
    <p>在不幸发生个人隐私数据泄露事件后，我们将依据法律法规要求，及时向您告知：个人隐私数据泄露的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时把事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。</p>
    <p>4.停止服务</p>
    <p>如果我们停止运营“正元签”的产品或服务，我们将及时停止继续收集您个人信息，将停止运营的通知以逐一送达或公告的形式通知您，并对我们存储的个人信息进行删除。</p>
    <p>六、您管理个人信息的权利</p>
    <p>我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</p>
    <p>(一)访问、更正</p>
    <p>我们鼓励您自行更新和修改您的信息以使其更准确有效。除法律规定外，您有权访问您的信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充。您可以联系我们的人工客服（010-62618866），申请更正您的信息，我们承诺在15个工作日内完成核查和处理。</p>
    <p>在访问、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障信息安全。</p>
    <p>(二)删除</p>
    <p>在以下情形中，您可以通过联系我们的人工客服（010-62618866）向我们提出删除个人信息的请求：</p>
    <p>1.如果我们处理个人信息的行为违反法律法规；</p>
    <p>2.如果我们收集、使用您的个人信息，却未征得您的授权同意；</p>
    <p>3.如果我们处理个人信息的行为违反了与您的约定；</p>
    <p>4.如果我们终止服务及运营。</p>
    <p>(三)返还、转移、索取数据副本</p>
    <p>您可以通过联系我们的人工客服（010-62618866）向我们提出返还、转移、索取个人信息副本的请求。我们承诺在15个工作日内完成核查和处理。</p>
    <p>(四)注销</p>
    <p>在您需要终止使用我们的服务时，您可以申请注销您的账户，您可以联系我们的人工客服（010-62618866），申请注销您的账户。我们承诺在15个工作日内完成核查和处理。</p>
    <p>我们在此善意地提醒您，您注销账户的行为会使您无法继续使用正元签电子合同的相关服务，包括合同下载等服务。注销账户后您的个人信息会保持不可被检索、访问的状态，我们将不会再使用或对外提供与该账户相关的个人信息，但您在使用正元签电子合同服务期间提供或产生的信息我们仍需按照监管要求的保存5年以上，且在保存的时间内依法配合有权机关的查询。</p>
    <p>七、本政策的变更和修订</p>
    <p>如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。</p>
    <p>本公司保留随时修改本政策的权利，因此请经常查看。如对本政策做出重大更改，本公司会通过网站通知的形式告知。本政策所指的重大变更包括但不限于:</p>
    <p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式;</p>
    <p>2、我们在控制权方面发生重大变化。如并购重组等引起的所有者变更;</p>
    <p>3、个人信息共享、转让或公开披露的主要对象发生变化;</p>
    <p>4、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时;</p>
    <p>5、个人信息安全影响评估报告表明存在高风险时。</p>
    <p>八、如何联系我们</p>
    <p>如果您对本隐私协议有任何疑问、意见或建议，通过以下方式与我们联系:</p>
    <p>电子邮件: yuanquanyun@jit.com.cn</p>
    <p>电话: 010-62618866</p>
    <p>一般情况下，我们将在十五天内回复。</p>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false
    }
  }
}
</script>